import { EMPTY_PIXEL } from "@/constants"

/**
 * Processes variant images for a product and extracts initial image data
 * @param {Object} pdpData - Product data from server
 * @param {string} skuId - SKU ID to process images for
 * @return {Object} Object containing variantImages, initialImgAlt, initialImgUrl, initialImageFullUrl
 */
export const processVariantImages = (pdpData, skuId) => {
  let variantImages = []
  let initialImgAlt = ""
  let initialImgUrl = ""
  let initialImageFullUrl = ""

  if (!skuId || !pdpData) {
    return {
      variantImages,
      initialImgAlt,
      initialImgUrl,
      initialImageFullUrl,
    }
  }

  let variants = []
  if (pdpData["variantList.sku_ss"]) {
    variants = pdpData["variantList.sku_ss"]
  }

  variantImages = pdpData["productImages.labelWithUrl_ss"]
    ? pdpData["productImages.labelWithUrl_ss"]
    : []

  let variantImageLabels = []
  let variantImageURLs = []

  if (variantImages?.length) {
    const selVarImageUrls = []
    const selVarImageLabels = []

    variantImages.forEach(img => {
      const imgDetail = img.split("|")
      if (skuId === imgDetail[0]) {
        selVarImageLabels.push(imgDetail[4] ?? "")
        selVarImageUrls.push(
          imgDetail[imgDetail.length - 1]
            ? imgDetail[imgDetail.length - 1]
            : EMPTY_PIXEL
        )
      } else if (!variants.find(v => v === imgDetail[0])) {
        variantImageLabels.push(imgDetail[4] ?? "")
        variantImageURLs.push(
          imgDetail[imgDetail.length - 1]
            ? imgDetail[imgDetail.length - 1]
            : EMPTY_PIXEL
        )
      }
    })

    variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
    variantImageURLs = [...selVarImageUrls, ...variantImageURLs]

    if (variantImageURLs.length < 1) {
      variantImageLabels.push(skuId)
      variantImageURLs.push(EMPTY_PIXEL)
    }
  } else {
    variantImageLabels.push(skuId)
    variantImageURLs.push(EMPTY_PIXEL)
  }

  const assetIdArray = variantImageURLs
    ? variantImageURLs[0].split("PAWEB/")
    : [""]

  initialImgAlt = variantImageLabels[0]
  initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : ""
  initialImageFullUrl =
    variantImageURLs.find(image => image.includes(initialImgUrl)) ?? ""

  return {
    variantImages,
    initialImgAlt,
    initialImgUrl,
    initialImageFullUrl,
  }
}
